import {Charging, Report, PropertyValue} from "../../types";
import React from "react";
import {BlockTitleComponent} from "../common/BlockTitleComponent";
import {TimePickerComponent} from "../common/TimePickerComponent";
import {HeaterChargingComponent} from "../heater/HeaterChargingComponent";

export interface EditGrindingReportProperties {
    report: Report;
    pelet_types: PropertyValue[],
    bag_types: PropertyValue[],
    onChange: any;
}

interface GrindingReportState {
    formValues: Map<string, any>,
    showFromPicker: boolean,
    showToPicker: boolean,
    chargings: Charging[],
}


export class EditGrindingReportComponent extends React.Component<EditGrindingReportProperties, GrindingReportState> {

    constructor(props: EditGrindingReportProperties) {
        super(props);

        const requestValues = props.report?.request_data ? Object.entries(JSON.parse(props.report.request_data)) : [];

        const formValues = new Map<string, any>();

        for (let [key, value] of requestValues) {
            formValues.set(key, value);
            if(this.props.onChange) this.props.onChange(key, value);
        }

        const chargings = (formValues.get('chargings') || [])
            .filter((i: any) => i)
            .map(
                (i: any) => {
                    return {...i} as Charging
                }
            );
        if (this.props.onChange) this.props.onChange('chargings', chargings);

        this.state = {
            formValues: formValues,
            showFromPicker: false,
            showToPicker: false,
            chargings: chargings,
        }

        this.handleFormChange = this.handleFormChange.bind(this);
        this.onChildChange = this.onChildChange.bind(this);
    }

    handleFormChange(event: any) {
        if (event) {
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            const name = target.name;

            this.setState(
                prevState => {
                    return {formValues: prevState.formValues.set(name, value)}
                }
            );

            if(this.props.onChange) this.props.onChange(name, value);
        }
    }

    onChildChange(key: string, items: any) {
        this.setState(
            prevState => {
                return {formValues: prevState.formValues.set(key, items), chargings: key === "chargings" ? items : prevState.chargings}
            }
        );
        if (this.props.onChange) this.props.onChange(key, items);
    }

    render() {
        return (
            <>
                <BlockTitleComponent title={"Зареждане"}/>
                <div className="row">

                    <div className="col-2">
                        <label className="form-label w-120px">
                            Час начало:
                            <input className="form-control" type="text" name="periodFrom" readOnly={true}
                                   required
                                   value={this.state.formValues?.get('periodFrom')}
                                   onChange={this.handleFormChange}
                                   onClick={() => this.setState({showFromPicker: !this.state.showFromPicker, showToPicker: false})}
                            /></label>
                        {
                            this.state.showFromPicker && <TimePickerComponent
                                onSelect={
                                    (time: string) => {
                                        this.setState({showFromPicker: false, formValues: this.state.formValues.set('periodFrom', time)});
                                        if(this.props.onChange) this.props.onChange('periodFrom', time);
                                    }
                                }
                                value={this.state.formValues?.get('periodFrom')}/>
                        }
                    </div>
                    <div className="col-2">
                        <label className="form-label w-120px">
                            Час край:
                            <input className="form-control" type="text" name="periodTo" readOnly={true}
                                   required
                                   value={this.state.formValues?.get('periodTo')}
                                   onChange={this.handleFormChange}
                                   onClick={() => this.setState({showToPicker: !this.state.showToPicker, showFromPicker: false})}
                            />
                        </label>
                        {
                            this.state.showToPicker && <TimePickerComponent
                                onSelect={
                                    (time: string) => {
                                        this.setState({showToPicker: false, formValues: this.state.formValues.set('periodTo', time)});
                                        if(this.props.onChange) this.props.onChange('periodTo', time);
                                    }
                                }
                                value={this.state.formValues?.get('periodTo')}/>
                        }
                    </div>

                    <div className="col-2">
                        <label className="form-label w-120px">
                            Глина (кофи):
                            <input className="form-control" type="number" name="clayQty"
                                   required
                                   value={this.state.formValues?.get('clayQty')}
                                   onChange={this.handleFormChange}
                            /></label>
                    </div>

                    <div className="col-2">
                        <label className="form-label w-120px">
                            Шлам (кофи):
                            <input className="form-control" type="number" name="sludgeQty"
                                   required
                                   value={this.state.formValues?.get('sludgeQty')}
                                   onChange={this.handleFormChange}
                            /></label>
                    </div>

                    <div className="col-4">
                        <label className="form-label w-160px">
                            Светъл отвор валове:
                            <input className="form-control" type="number" name="valsFuga"
                                   required
                                   value={this.state.formValues?.get('valsFuga')}
                                   onChange={this.handleFormChange}
                            /></label>
                    </div>

                </div>

                <div className="form-row mb-3">
                    <div className="col-12 m-0 p-0">
                        <BlockTitleComponent title={"Разход пелети в мелене"}/>
                        <HeaterChargingComponent report={this.state.chargings}
                                                 pelet_types={this.props.pelet_types}
                                                 bag_types={this.props.bag_types}
                                                 onChange={this.onChildChange}/>
                    </div>
                </div>

                <BlockTitleComponent title={"Бележки към отчета"}/>
                <div className="col-12 p-0 m-0">
                                <textarea className="form-control" rows={3} name="comments" onChange={this.handleFormChange}
                                          value={this.state.formValues.get('comments')}/>
                </div>
            </>
        )
    }
}
